exports = module.exports = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/** 常用色值 **/\n/** 常用字体大小 **/\n.login {\n  width: 100%;\n  height: 100vh;\n  background-image: url(" + require("../../assets/login-bg/bg-5.jpg") + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.login .login-box {\n  max-width: 400px;\n  padding: 150px 15px 50px;\n  margin: 0 auto;\n}\n.login .login-box .title {\n  color: #fff;\n  font-size: 26px;\n  text-align: center;\n  margin-bottom: 50px;\n}\n.login .login-box .title img {\n  width: 8em;\n}\n.login .ant-input-affix-wrapper {\n  font-size: 18px;\n}\n.login .ant-input {\n  padding-left: 36px!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader?{"importLoaders":1}!./node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./src/pages/login/index.less
// module id = 539
// module chunks = 20